<!--
 * @Author: lan.h
 * @Date: 2022-02-18 16:05:33
 * @LastEditors: lan.h
 * @LastEditTime: 2022-05-13 15:10:57
 * @Description: 广告位
-->
<template>
  <div class="poster">
    <a v-if="banner40.imgPath" class="poster1" :href="banner40.link" target="_blank">
      <img :src="banner40.imgPath | logo_show">
    </a>
    <div class="poster3" v-if="listtype == 0">
      <a v-for="a, index in article_list" :key="index" :href="$store.state.index2_path + '/seriesD/' + a.id" class="series" target="_bank">
        <img :src="a.logoPath | logo_show">
        <div class="mask">
          <span class="icon_column">专题</span>
          <span class="title over-p1">{{a.title}}</span>
          <span class="summary over-p2">{{a.summary}}</span>
        </div>
      </a>
      <a class="more" @click="goList" target="_blank">查看更多</a>
    </div>
  </div>
</template>
<script>
import { articleseries } from '../../../service'

export default {
  props: ['banner40', 'listtype'],
  data() {
    return {
      article_list: []
    }
  },
  created() {
    this.getArticleseries()
  },
  methods: {
    async getArticleseries() {
      let res = await articleseries({
        type: this.listtype
      }, (error) => {
        this.$message.error('请求错误！')
      })
      if (res.code == 0) {
        this.$set(this.$data, 'article_list', res.data)
      } else {
        this.$message.error(res.msg)
      }
    },
    goList() {
      let url = this.$store.state.index_path + '/liveTheme?type=' + this.listtype
      window.open(url)
    }
  }
}
</script>

<style lang="stylus" scoped>
.poster1, .poster3
  img
    width 100%
    height 100%
.poster1:hover, .poster3 a:hover
  img
    transform scale(1.1)
    transition all 0.5s ease 0s
.poster1
  width 806px
  height 80px
  display block
  overflow hidden
.poster3
  margin-top 20px
  display flex
  justify-content space-between
  .series
    width 242px
    height 152px
    overflow hidden
    position relative
    cursor pointer
    .mask
      position absolute
      top 0
      left 0
      right 0
      bottom 0
      background rgba(0, 0, 0, 0.4)
      .icon_column
        position absolute
        left 10px
        top 10px
        background rgba(29, 168, 242, 0.8)
        padding 6px
        color #fff
        line-height 1
      .title
        font-size 18px
        color #FFFFFF
        line-height 20px
        position absolute
        left 10px
        bottom 55px
      .summary
        font-size 14px
        font-weight 500
        color #FFFFFF
        line-height 20px
        height 37px
        position absolute
        left 10px
        bottom 10px
  .more
    width 36px
    height 152px
    background #FFFFFF
    border 1px solid #F9A864
    color #FA5A00
    font-size 12px
    font-weight 400
    line-height 24px
    transition all 0.5s
    display flex
    align-items center
    padding 10px
    text-align: center
    cursor pointer
    &:hover
      color #FF4800
      border 1px solid #FF4800
</style>